/**
 * サイズの絞り込みを「商品種類（またはテーマ）を選ぶまで隠す」
 * =====================================================================
 * なぜ必要か:
 *   サイズは50種あり、同じ「M」が大人・子供・ベビーで共通して使われている。
 *   全部が混ざって出ると区別がつかないが、商品種類（テーマページの場合）や
 *   テーマ（商品種類ページの場合）を選ぶと、Shopifyがその範囲で実際に使われている
 *   サイズだけに絞ってくれる（実測: ディズニー30種 → 大人男性用6種）。
 *   そこで、タグの絞り込みが選ばれるまではサイズの枠ごと隠しておく。
 *
 * なぜJavaScriptなのか:
 *   Liquid側で「描画しない」にすると、絞り込みをクリックしたときに枠が出てこない。
 *   テーマは絞り込みを更新するとき **既にある枠の中身だけ** を差し替える作りなので、
 *   枠そのものが無いと差し替え先が無く、ページを読み直すまで現れない。
 *   → 枠は常に置いておき、表示/非表示をここで切り替える。
 *
 * 初期状態はLiquid側が style="display:none" を付けている（最初の描画でチラつかせないため）。
 */
(function () {
  var SIZE_SELECTOR = '.facets--size';

  function hasTagFilter() {
    var params = new URL(window.location.href).searchParams;
    var found = false;
    params.forEach(function (value, key) {
      if (key.indexOf('filter.p.tag') !== 0) return;
      // 検索結果ページ(window.sizeFacetToggleCatOnly=true)では、テーマを選んでもサイズは出さず、
      // 商品種類(cat_タグ)を選んだときだけ出す(2026-09-05)。値はLiquid側(facets.liquid)が入れる
      if (window.sizeFacetToggleCatOnly) {
        if (value.indexOf('cat_') === 0) found = true;
      } else {
        found = true;
      }
    });
    return found;
  }

  function update() {
    var show = hasTagFilter();
    var items = document.querySelectorAll(SIZE_SELECTOR);
    for (var i = 0; i < items.length; i++) {
      items[i].style.display = show ? '' : 'none';
    }
  }

  function init() {
    // 商品種類のページ（大人男性用コスチューム等）では隠さない。
    // ページ自体が商品種類なので、サイズの意味はすでに定まっているため。
    if (window.sizeFacetToggleEnabled === false) return;

    update();

    // 絞り込み・並び替えを操作するとテーマが商品一覧を差し替える（URLも書き換わる）。
    // そのタイミングで見直す。
    var container = document.getElementById('ProductGridContainer');
    if (container && window.MutationObserver) {
      var timer = null;
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(update, 50);
      }).observe(container, { childList: true });
    }

    // 戻る・進むでも見直す
    window.addEventListener('popstate', update);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
